import {
  supabase,
  isConfigured,
  storePendingMarketingConsent,
  checkRateLimits,
  logEvent,
} from '@rehub/supabase';
import { checkAdminStatus } from '@rehub/admin';

export {
  supabase,
  isConfigured,
  storePendingMarketingConsent,
  checkRateLimits,
  logEvent,
};

// Stripe billing portal (invoices, payment methods, subscriptions). Shared
// across every ReHub app via @rehub/commerce + the single Supabase project.
import { openBillingPortal as openBillingPortalShared } from '@rehub/commerce';
export const openBillingPortal = (returnUrl?: string) =>
  openBillingPortalShared(supabase, returnUrl);

export const isAdmin = (userId: string) => checkAdminStatus(supabase, userId);
